// @core/api/endpoints/subscription/update_tenant_subscription.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ProductTenantResponse,
  UpdateTenantSubscriptionRequest,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Update tenant subscription
 * Updates the tenant's product subscription, allowing plan changes or billing account modifications.
 */
export async function UpdateTenantSubscription(
  tenant_id: string,
  product_id: string,
  data: UpdateTenantSubscriptionRequest,
  options?: RequestOptions
): Promise<ProductTenantResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tenants/:tenant_id/products/:product_id`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = options;
  return client.put<ProductTenantResponse>(requestPath, data, requestOptions);
}
